import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { LIST_GRID_CLASSNAME, LIST_GRID_CONTAINER_CLASSNAME, LIST_GRID_TWO_ROW_CLAMP } from '@/shared/components/itemList/listGrid';
import { SectionHeader } from '@/shared/components/SectionHeader';
import { FolderCard } from '@/shared/features/quiz-folder';
import { cn } from '@/utils/tailwind.util';
import { useUserFolderPreview } from '../hooks/useUserFolderPreview';

/** 이 섹션의 카드가 이벤트에 싣는 자리. */
const PLACE = 'user_profile_section';

/**
 * 남의 프로필의 공개 폴더 섹션. 내 퀴즈 폴더 섹션과 같은 두 줄 규칙이고 `새 폴더` 카드·카드 메뉴만 없다.
 *
 * 카드를 누르면 폴더 상세(`/folder/{id}`)로 간다. 남의 폴더는 상세에서 안내 카드만 보이고 편집 CTA 가 없다.
 * 두 줄에 다 못 담으면 제목 옆 `N개 ›` 로 공개 폴더 전체 페이지에 넘긴다. 이 섹션이 검색어·정렬로 걸러져 있으므로
 * 같은 조건을 실어 보낸다 — 전체 페이지의 돌아가기 링크(`UserFolderListPageView`)도 조건을 그대로 돌려준다.
 */
export const UserFolderSection = ({
  userHashId
}: {
  userHashId: string;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    folders,
    totalCount,
    hasMore
  } = useUserFolderPreview(userHashId);
  const {
    query
  } = useRouter();
  const {
    userHashId: _omit,
    ...listQuery
  } = query;
  return <section className={'flex w-full flex-col'} data-sentry-component="UserFolderSection" data-sentry-source-file="UserFolderSection.tsx">
      <SectionHeader title={t('common:folder.label.folders')} count={t('common:formatNumber.count', {
      n: totalCount.toLocaleString()
    })} href={hasMore ? {
      pathname: `/profile/${userHashId}/folders`,
      query: listQuery
    } : undefined} data-sentry-element="SectionHeader" data-sentry-source-file="UserFolderSection.tsx" />
      <div className={LIST_GRID_CONTAINER_CLASSNAME}>
        <div className={cn(LIST_GRID_CLASSNAME, LIST_GRID_TWO_ROW_CLAMP)}>
          {folders.map(folder => <FolderCard key={folder.id} folder={folder} place={PLACE} href={`/folder/${folder.id}`} />)}
        </div>
      </div>
    </section>;
};